import { render, staticRenderFns } from "./TwoColumnRow.vue?vue&type=template&id=2a2cb097&scoped=true&"
import script from "./TwoColumnRow.vue?vue&type=script&lang=ts&"
export * from "./TwoColumnRow.vue?vue&type=script&lang=ts&"
import style0 from "./TwoColumnRow.vue?vue&type=style&index=0&id=2a2cb097&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2cb097",
  null
  
)

export default component.exports